import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { ALL_USERS_GROUP_ID } from '../constants';
import type { Group, GroupWithPermissions } from '../types';

export const useGroupsWithLocalizedAllUsersGroup = <T extends Group | GroupWithPermissions>(groups: T[]) => {
    const { formatMessage } = useIntl();

    return useMemo(() => {
        const allUsersGroup = groups.find(group => group.id === ALL_USERS_GROUP_ID);
        const hasAllUsersGroup = Boolean(allUsersGroup);

        return [
            hasAllUsersGroup && {
                ...allUsersGroup,
                name: formatMessage({ id: 'secret.groups.allUsers.label' }),
            },
            ...groups.filter(group => group.id !== ALL_USERS_GROUP_ID),
        ].filter(Boolean) as T[];
    }, [groups, formatMessage]);
};
